var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopLightFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 128L128 128C110.3 128 96 142.3 96 160L96 384L64 384L64 160C64 124.7 92.7 96 128 96L512 96C547.3 96 576 124.7 576 160L576 384L544 384L544 160C544 142.3 529.7 128 512 128zM87.1 512L552.9 512C580.9 512 604.1 491.1 607.6 464L32.5 464C36 491.1 59.1 512 87.2 512zM0 456.9C0 443.1 11.1 432 24.9 432L615.1 432C628.8 432 640 443.1 640 456.9C640 505 601 544 552.9 544L87.1 544C39 544 0 505 0 456.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopLightFull);
export default __webpack_public_path__ + "static/media/laptop-light-full.cb40ebc921ca6e4d2589b0299819714c.svg";
export { ForwardRef as ReactComponent };